module.exports = __webpack_public_path__ + "static/media/photo8.deb3d1d4.jpg";